/**
 * @generated SignedSource<<0d0797c94672fc6f926a6ad47cb09a30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PaymentProcessor = "BRAINTREE" | "KLARNA" | "OFF_PLATFORM" | "STRIPE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type WalletCreditCardOption_creditCard$data = {
  readonly billingAddress: {
    readonly city: string | null;
    readonly company: string | null;
    readonly country: string | null;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly line1: string | null;
    readonly line2: string | null;
    readonly state: string | null;
    readonly zipCode: string | null;
  } | null;
  readonly cardExpiryMonth: string | null;
  readonly cardExpiryYear: string | null;
  readonly cardHolderName: string | null;
  readonly cardLogo: string | null;
  readonly cardType: string | null;
  readonly formattedTextMaskedCardNumber: string | null;
  readonly hashedCardNumber: string | null;
  readonly maskedCardNumber: string | null;
  readonly paymentProcessor: PaymentProcessor | null;
  readonly token: string | null;
  readonly " $fragmentType": "WalletCreditCardOption_creditCard";
};
export type WalletCreditCardOption_creditCard$key = {
  readonly " $data"?: WalletCreditCardOption_creditCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"WalletCreditCardOption_creditCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WalletCreditCardOption_creditCard",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardLogo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardExpiryMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardExpiryYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentProcessor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedTextMaskedCardNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardHolderName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maskedCardNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hashedCardNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "billingAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "line1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "line2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "country",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "zipCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "company",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CreditCard",
  "abstractKey": null
};

(node as any).hash = "6fca2fc5f1f3a231b8c4abfcdbf2b4ae";

export default node;
